import { PayloadAction } from '@reduxjs/toolkit';
import { IRootState } from './type';

const reducers = {
  setDashboardData: (state: IRootState, action: PayloadAction<IRootState['dashboardData']>) => ({
    ...state,
    dashboardData: action.payload,
  }),
  setYearlyData: (state: IRootState, action: PayloadAction<IRootState['yearlyData']>) => ({
    ...state,
    yearlyData: action.payload,
  }),
  setPreset: (state: IRootState, action: PayloadAction<IRootState['preset']>) => ({
    ...state,
    preset: action.payload,
  }),
};

export {
  reducers,
};
